import Vue from 'vue';
import VueRouter from 'vue-router';
import CalendarioFerias from "../views/calendario-ferias/CalendarioFerias.vue";
import Tmp from "../views/tmp/Tmp.vue";
import GerenciarUsuarios from "../views/gerenciar-usuarios/GerenciarUsuarios.vue";
import ParametrizarCalendario from "../views/configuracoes/parametrizar-calendario/ParametrizarCalendario.vue";
import AtribuirFeriados from "../views/configuracoes/atribuir-feriados/AtribuirFeriados.vue";
import CalendarioFeriasEscolares from '../views/ferias-escolares/calendario-ferias-escolares/CalendarioFeriasEscolares.vue'
import DiscenteFerias from '../views/ferias-escolares/discente-ferias/DiscenteFerias.vue'
import MapeamentoFerias from '../views/mapeamento-ferias/MapeamentoFerias.vue'
import HistoricoFerias from '../views/calendario-ferias/historico-ferias/HistoricoFerias.vue'
import HistoricoFeriasAnual from '../views/calendario-ferias/historico-ferias-anual/HistoricoFeriasAnual.vue'
import HistoricoFeriasPremio from '../views/calendario-ferias/historico-ferias-premio/HistoricoFeriasPremio.vue'
import Boletim from '../views/boletim/Boletim.vue'
import Comparativo from '../views/configuracoes/comparativo/Comparativo'
import PesquisarCivis from '../views/ferias-civis/pesquisar-civis/PesquisarCivis.vue'
import ParametrizarCalendarioCivis from '../views/ferias-civis/configuracoes/parametrizar-calendario/ParametrizarCalendarioCivis.vue'
import AtribuirFeriadosCivis from '../views/ferias-civis/configuracoes/atribuir-feriados/AtribuirFeriados.vue'
import CalendarioCivis from '../views/ferias-civis/calendario-ferias/CalendarioFerias.vue'
import HistoricoCivis from '../views/ferias-civis/historico-ferias/HistoricoFerias.vue'
import store from '../store'
import { tipoPerfil } from "../constants";


Vue.use(VueRouter)
// const menuPermissao = store.state.lista_menu;

function verificarPermissaoRota (next, rotaAcessada){
  const permissaoExiste = Object.values(store.state.lista_menu).find(({ rota }) => rota === rotaAcessada );
    if(permissaoExiste != undefined){
      return next();
    }
    return next('/');
}

function verificarCivilGerente(next) {
  const verificarGerenteCivil = store.state.user.Perfis.indexOf(tipoPerfil['GERENCIA']) !== -1;
  if(verificarGerenteCivil){
    return next();
  }

  return next('/');
}

function verificarPermissaoAtribuirFeriados(next, rotaAcessada = '') {
  const permissaoExiste = Object.values(store.state.lista_menu).find(({ rota }) => rota === rotaAcessada);
  const verificarGerenteCivil = store.state.user.Perfis.indexOf(tipoPerfil['GERENCIA']) !== -1;
  if (permissaoExiste != undefined || verificarGerenteCivil) {
    return next();
  }
  return next('/');
}

const routes = [{
    path: "/",
    name: "CalendarioFerias",
    beforeEnter (to, from, next)  {return store.state.user.civil ==1 ? next('/calendario-civis') : next();},
    component: CalendarioFerias,
  },
  {
    path: "/gerenciar-usuarios",
    name: "GerenciarUsuarios",
    beforeEnter (to, from, next)  {return verificarPermissaoRota(next, '/gerenciar-usuarios')},
    component: GerenciarUsuarios,
  },
  {
    path: "/mapeamento-ferias",
    name: "MapeamentoFerias",
    beforeEnter (to, from, next)  {return verificarPermissaoRota(next, '/mapeamento-ferias')},
    component: MapeamentoFerias,
  },
  {
    path: "/configuracoes/parametrizar-calendario",
    name: "ParametrizarCalendario",
    beforeEnter (to, from, next)  {return verificarPermissaoRota(next, '/#')},
    component: ParametrizarCalendario,
  },
  {
    path: "/configuracoes/atribuir-feriados",
    name: "AtribuirFeriados",
    beforeEnter (to, from, next)  {return verificarPermissaoAtribuirFeriados(next, '/#')},
    component: AtribuirFeriados,
  },
  {
    path: "/configuracoes/comparativo",
    name: "Compararativo",
    beforeEnter (to, from, next)  {return verificarPermissaoRota(next, '/configuracoes/comparativo')},
    component: Comparativo,
  },
  {
    path: "/ferias-escolares/calendario-ferias-escolares",
    name: "CalendarioFeriasEscolares",
    beforeEnter (to, from, next)  {return verificarPermissaoRota(next, '/ferias-escolares/feriasescolares')},
    component: CalendarioFeriasEscolares,
  },
  {
    path: "/ferias-escolares/discente-ferias",
    name: "DiscenteFerias",
    beforeEnter (to, from, next)  {return verificarPermissaoRota(next, '/ferias-escolares/feriasescolares')},
    component: DiscenteFerias,
  },
  {
    path: "/calendario-ferias/boletim",
    name: "Boletim",
    component: Boletim,
  },
  {
    path: "/calendario/historico",
    name: "HistoricoFerias",
    
    component: HistoricoFerias,
  },
  {
    path: "/calendario/historico-anual",
    name: "HistoricoFeriasAnual",
    component: HistoricoFeriasAnual,
  },
  {
    path: "/calendario/historico-premio",
    name: "HistoricoFeriasPremio",
    component: HistoricoFeriasPremio,
  },
  {
    path: "/pesquisar-civis",
    name: "PesquisarCivis",
    component: PesquisarCivis,
  },
  {
    path: "/ferias-civis/configuracoes/parametrizar-calendario",
    name: "ParametrizarCalendarioCivis",
    beforeEnter (to, from, next)  {return verificarCivilGerente(next)},
    component: ParametrizarCalendarioCivis,
  },
  {
    path: "/ferias-civis/configuracoes/atribuir-feriados",
    name: "AtribuirFeriadosCivis",
    beforeEnter (to, from, next)  {return verificarPermissaoAtribuirFeriados(next)},

    component: AtribuirFeriadosCivis,
  },
  {
    path: "/calendario-civis",
    name: "CalendarioCivis",
    component: CalendarioCivis,
  },
  {
    path: "/historico-civis",
    name: "HistoricoCivis",
    component: HistoricoCivis,
  },
  {
    path: "/tmp",
    name: "Tmp",
    component: Tmp,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router